import { useLocation } from 'react-router-dom'

export const useQueryParam = (paramName: string) => new URLSearchParams(useLocation().search).get(paramName)
